import * as React from 'react'

const Grid = ({ children }) => (
  <div className="max-w-7xl mx-auto px-3 md:px-12 xl:px-0 grid gap-6 grid-cols-1 lg:grid-cols-3">
    { children }
  </div>
)

export default Grid